<template>
  <div>
    <div class="container">
      <!-- 头部操作 -->
      <!-- 占位 -->
      <div class="seat"></div>

      <!-- 表格区域 -->
      <div class="table_title">转换学员详情列表</div>
      <StudentsTableHeader
        id="CourseConversionStudentListNew"
        :empty-text="emptyText"
        ref="CourseConversionStudentListNew"
        componentTableId="CourseConversionStudentListNew"
        :table-height="750"
        excelName="转换学员详情列表"
        :header-data="headerData"
        :element-loading-text="loadingText"
        @update-list="getData"
        :table-data="tableData"
        :table-loading="tableLoading"
        @search-data="tableSearch"
        @handleSelectionChange1="handleSelectionChange"
        @search-remote ="searchRemote"
      >
        <template v-slot:studentNamecustom="scope">
          <template v-if="scope.scope.remarks && scope.scope.remarks?.length > 0">
            <el-tooltip
              popper-class="mt35"
              effect="dark"
              content="点击查看备注信息列表"
              placement="bottom"
            >
              <el-tag @click="handleScopeCourse(scope.scope, 'remarks')"
                >备注{{ scope.scope.remarks?.length }}</el-tag
              >
            </el-tooltip>
          </template>
          <span
            class="blue"
            v-if="scope.scope.studentName"
            @click="openDialog(scope.scope)"
            >{{ scope.scope.studentName }}</span
          >
          <span v-else class="gray" @click="openDialog(scope.scope)">未设置</span>
        </template>

        <template v-slot:payCoursescustom="scope">
          <template v-if="scope.scope.payCourses && scope.scope.payCourses?.length > 0">
            <el-tooltip
              popper-class="mt35"
              effect="dark"
              content="点击查看购买的课程列表"
              placement="bottom"
            >
              <span class="hand" @click="handleScopeCourse(scope.scope, 'PayCourse')">
                共购买
                <span class="blue">
                  {{ scope.scope.payCourses?.length }} </span
                >个课程
              </span>
            </el-tooltip>
          </template>
          <span v-else class="gray">还未购买课程</span>
        </template>

        <template v-slot:createTimecustom="scope">
          <span class="" v-if="scope.scope.createTime">{{
            timeFormatNew(scope.scope.createTime, "yyyy-MM-dd")
          }}</span>
          <span v-else class="gray">未设置</span>
        </template>
      </StudentsTableHeader>

      <!-- 底部工具 -->
      <pagination-tool
        :pagination="pagination"
        :is-loading="tableLoading"
        @change-pagination="changePagination"
      >
      </pagination-tool>
      <!--购买的课程弹框-->
      <el-dialog
        :title="CourseTitle"
        :visible.sync="dialogVisibleCourse"
        v-if="dialogVisibleCourse"
        width="1200px"
        v-dialogDrag
        top="15vh"
        :close-on-click-modal="false"
      >
        <div class="dialog_div2">
          <el-table
            :data="payCourseList"
            style="width: 100%"
            border
            height="420px"
            stripe
            :header-cell-style="{ background: '#f5f7fa' }"
          >
            <el-table-column width="430" prop="title" label="课程标题"></el-table-column>
            <el-table-column prop="payMoney" label="实付金额(元)" align="center">
              <template scope="scope">
                <span v-if="scope.row.payMoney">{{ scope.row.payMoney }}元</span>
                <span v-else>免费</span>
              </template>
            </el-table-column>
            <el-table-column prop="gradeName" label="所属班级" align="center" width="410">
              <template scope="scope">
                <span v-if="scope.row.gradeName">{{ scope.row.gradeName }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="payTime" label="购买时间" width="180" align="center">
              <template scope="scope">
                <span v-if="scope.row.payTime">{{
                  timeFormatNew(scope.row.payTime, "yyyy-MM-dd hh:mm:ss")
                }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <!--备注信息弹框-->
      <el-dialog
        :title="remarksTitle"
        :visible.sync="dialogVisibleRemarks"
        v-if="dialogVisibleRemarks"
        width="1000px"
        v-dialogDrag
        top="15vh"
        :close-on-click-modal="false"
      >
        <div class="dialog_div2">
          <el-table
            :data="remarksList"
            style="width: 100%"
            border
            height="420px"
            stripe
            :header-cell-style="{ background: '#f5f7fa' }"
          >
            <el-table-column prop="createTime" label="日期" width="180" align="center">
              <template scope="scope">
                <span v-if="scope.row.createTime">{{
                  timeFormatNew(scope.row.createTime, "yyyy-MM-dd hh:mm:ss")
                }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="adminName" label="操作人" width="180" align="left">
              <template scope="scope">
                <span v-if="scope.row.adminName">{{ scope.row.adminName }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
            <el-table-column prop="contents" label="备注内容" align="left">
              <template scope="scope">
                <span v-if="scope.row.contents">{{ scope.row.contents }}</span>
                <span v-else class="gray">未设置</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <!-- 学生详情弹框（新） -->
        <StudentDialog
          title="学生详情"
          :show.sync="dialogVisibleDetail"
          v-if="dialogVisibleDetail"
          :isFooter="false"
          @isfullscreen="isfullscreen"
        >
      <div class="abow_dialog3" slot="body">
        <StudentDetailNew
          :isService="true"
          v-if="dialogVisibleDetail"
          :studentId="studentId"
          :isFullscreen='isFullscreen'
          class="dialog_div_detail1"
        ></StudentDetailNew>
      </div>
   </StudentDialog>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import StudentsTableHeader from "components/StudentList";
import PaginationTool from "components/PaginationTool";
import { GetAllStudentPage } from "../../network/statistics.js";
import { isNull, timeFormatNew } from "../../common/utils";
import { GetAdminList } from "../../network/businessGroup.js";
import { GetCatetListByType } from "network/studentSortModule";
import { getAdminList } from "network/administrator";
import StudentDetailNew from "../studentsV2/studentDetailNew.vue";
export default {
  name: "CourseConversionStudentListNew",
  components: {
    PaginationTool,
    StudentsTableHeader,
    StudentDetailNew,
  },
  props: {
    tableMaxHeight: Number,
  },
  data() {
    return {
      isFullscreen:false,
      emptyText: "暂无数据",
      ResultInfo1: "",
      ViewResultsTitle: "",
      ViewResults: false,
      tableLoading: false,
      loadingText: "loading...", //加载状态提示文本
      systemInfo: {
        reportBeginTime: "",
        reportEndTime: "",
        reportSource: 0,
        reportPayMoney: 0,
        type: null,
        name: "",
        telNumber: "",
        qqNumber: "",
        grade: 0,
        businessId: 0,
        handoverId: 0,
        source: 0,
        PageIndex: 1,
        PageSize: 20,
        studentIds: [],
      },
      handleSelection: [], //选中的数据
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      type: null,
      tableData: [],
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          align: "center",
          width: "55",
          fixed: "left",
        },
        {
          label: "学员姓名",
          prop: "studentName",
          width: "200",
          align: "left",
          inputSearch: true,
          fixed: "left",
          // noSetText: "未设置",
          // noTooltip: true,
          custom: true,
        },
        {
          label: "手机号",
          prop: "telNumber",
          inputSearch: true,
          width: "180",
          align: "center",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "qq号",
          prop: "qqNumber",
          align: "center",
          width: "160",
          inputSearch: true,
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "缴费总金额",
          prop: "payMoney",
          align: "center",
          width: "160",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "登记时间",
          prop: "createTime",
          align: "center",
          width: "160",
          noSetText: "未设置",
          // noTooltip: true,
          custom: true,
        },

        {
          label: "报名课程",
          prop: "payCourses",
          align: "center",
          width: "160",
          noSetText: "未设置",
          // noTooltip: true,
          custom: true,
        },
        {
          label: "所在年级",
          prop: "gradeStr",
          align: "center",
          width: "160",
          noSetText: "未设置",
        },
        {
          label: "所属业务老师",
          prop: "businessName",
          align: "center",
          width: "260",
          noSetText: "未设置",
          noTooltip: true,
          selectSearch: true,
          businessName: null,
          selectOptions: "",
          remoteMethod: true,
        },
        {
          label: "所属教务老师",
          prop: "handoverName",
          align: "center",
          width: "260",
          noSetText: "未设置",
          noTooltip: true,
          selectSearch: true,
          handoverName: null,
          selectOptions: "",
          remoteMethod: true,
        },
        {
          label: "来源渠道",
          prop: "sourceStr",
          align: "left",
          width: "260",
          noSetText: "未设置",
          noTooltip: true,
          cascader: true,
          sourceStr: null,
          selectOptions: [],
          // selectAll: true,
        },
        {
          label: "专科院校",
          prop: "graduatedSchool",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "专科专业",
          prop: "graduatedMajor",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "英语基础",
          prop: "basicEnglishStr",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "报名时间",
          prop: "signUpTime",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "报考院校",
          prop: "applySchool",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "报考专业",
          prop: "applyMajor",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },

        {
          label: "报考院校备选",
          prop: "applySchoolTo",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "报考专业备选",
          prop: "applyMajorTo",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "录取状态",
          prop: "admissionStr",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "录取院校",
          prop: "admissionSchool",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
        {
          label: "录取专业",
          prop: "admissionMajor",
          align: "center",
          width: "200",
          noSetText: "未设置",
          noTooltip: true,
        },
      ],
      //课程弹窗
      dialogVisibleCourse: false,
      payCourseList: [],
      CourseTitle: "",
      //备注弹窗
      dialogVisibleRemarks: false,
      remarksList: [],
      remarksTitle: "",
      beginTime: "",
      endTime: "",
      PayMoney: "",
      // 来源渠道
      sourseList: [],
      sourseList1: [],
      //学生详情
      dialogVisibleDetail: false,
      studentId: null,
      detailRow: {},
      businessList: [],
      educationalList: [],
      adminList: [],
    };
  },
  created() {
    // let params = new URLSearchParams(window.location.search);
    // this.beginTime = timeFormatNew(params.get('beginTime'), 'yyyy-MM-dd')
    // this.endTime = timeFormatNew(params.get('endTime'), 'yyyy-MM-dd')
    // this.PayMoney = params.get("money");
    // this.systemInfo.reportPayMoney = this.PayMoney;
    // // 使用 split() 方法将字符串按逗号拆分成多个子字符串，并将拆分的结果存储在一个临时数组中
    // var tempArray = params.get("studentIds")?.split(",");
    // // 遍历临时数组，将每个子字符串添加到之前定义的空数组中
    // for (var i = 0; i < tempArray.length; i++) {
    //   // 去除空格并添加到数组
    //   this.systemInfo.studentIds.push(tempArray[i].trim());
    // }
    let query = JSON.parse(this.getQueryParams().data); //参数部分
    this.PayMoney = query.money ? query.money : {}
    // this.PayMoney = window.opener.money ? window.opener.money : {}
    // this.systemInfo.reportPayMoney = window.opener.money ? window.opener.money : {}
    this.systemInfo.studentIds = window.opener.studentIds ? window.opener.studentIds : []
    this.systemInfo.studentIds = query.studentIds ? query.studentIds : []
    this.systemInfo.type = this.type * 1;
    setTimeout(() => {
      if (sessionStorage?.getItem("AdminToken")) {
        let adminInfo = sessionStorage?.getItem("AdminToken")
          ? JSON.parse(sessionStorage?.getItem("AdminToken"))
          : [];
        let expiresTime = adminInfo?.expires_in + new Date() / 1000;
        const token = {
          AccessToken: adminInfo?.access_token,
          AccessExpiresIn: expiresTime,
          RefreshToken: adminInfo?.refresh_token,
        };
        if (token) this.$store.commit("updateToken", token);
        sessionStorage.removeItem("AdminToken"); //移除
      }
      this.getStudentCategoryList();
      this.getTeacherList();
      this.getData();
    }, 1000);
  },
  methods: {
    async searchRemote(val){
      let businessRoleId = this.$store.state.allConfig.businessRoleId
      let educationalRoleId = this.$store.state.allConfig.educationalRoleId
      let operationRoleId = this.$store.state.allConfig.operationRoleId
      let marketingRoleId = this.$store.state.allConfig.marketingRoleId
      let data = {
        ids: [],
        keyWord: val.value,
        pageSize: 50,
        adminTypeIds: []
      };
      if(val.prop === 'businessName'){
        data.adminTypeIds = [businessRoleId]
      }else if(val.prop === 'handoverName'){
        data.adminTypeIds = [educationalRoleId]
      }else if(val.prop === 'adminName'){
        data.adminTypeIds = [educationalRoleId, businessRoleId, operationRoleId, marketingRoleId]
      }
      let res = await GetAdminList(data);
        for (let item of this.headerData) {
          if (item.prop === val.prop) {
            item.selectOptions = res.result;
            item.selectOptions.unshift({ id: 0, name: "全部" });
          }
        }
    },
    getQueryParams() {
      const queryParams = {};
      const hash = window.location.hash;
      const queryString = hash.substring(hash.indexOf('?') + 1); // 提取问号后的部分

      if (!queryString) {
        return queryParams; // 如果没有查询参数，直接返回空对象
      }

      const queryArray = queryString.split("&");
      for (let i = 0; i < queryArray.length; i++) {
        const keyValue = queryArray[i].split("=");
        const key = decodeURIComponent(keyValue[0]);
        const value = decodeURIComponent(keyValue[1] || "");
        queryParams[key] = value;
      }
      return queryParams;
    },
    // 是否全屏
   isfullscreen(val){
      this.isFullscreen = val;
    },
    // 获取老师列表
    async getTeacherList() {
      var businessRoleId =
        this.$store.state.allConfig.businessRoleId ||
        sessionStorage.getItem("allConfig").businessRoleId;
      var educationalRoleId =
        this.$store.state.allConfig.educationalRoleId ||
        sessionStorage.getItem("allConfig").educationalRoleId;
      let data = {
        ids: [],
        keyWord: "",
        pageSize: 0,
        adminTypeIds: [educationalRoleId, businessRoleId],
      };

      const res = await GetAdminList(data);
      if (res && res.code && res.code == 0) {
        this.$alert(res.message);
        return false;
      } else {
        this.adminList = res.result;
      }
      if (!isNull(this.adminList)) {
        res.result.forEach((item) => {
          if (item.rolesId == businessRoleId) {
            this.businessList.push({ key: item.id, value: item.name });
          } else if (item.rolesId == educationalRoleId) {
            this.educationalList.push({ key: item.id, value: item.name });
          }
        });
        for (let item of this.headerData) {
          if (item.prop === "businessName") {
            item.selectOptions = this.businessList;
            item.selectOptions.unshift({ key: "0", value: "全部" });
          }
          if (item.prop === "handoverName") {
            item.selectOptions = this.educationalList;
            item.selectOptions.unshift({ key: "0", value: "全部" });
          }
        }
      }
    },
    //点击弹框
    openDialog(row) {
      this.studentId = row.id + 0;
      this.detailRow = row;
      this.dialogVisibleDetail = true;
    },
    timeFormatNew,
    // 获取管理员
    async getRoleList() {
      let businessRoleId = this.$store.state.allConfig.businessRoleId
      let educationalRoleId = this.$store.state.allConfig.educationalRoleId
      let operationRoleId = this.$store.state.allConfig.operationRoleId
      let marketingRoleId = this.$store.state.allConfig.marketingRoleId
      const parObj = { ids: [], keyWord: "", pageSize: 50, adminTypeIds: [educationalRoleId, businessRoleId, operationRoleId, marketingRoleId] };
      const res = await GetAdminList(parObj);
      let data = [];
      res.result?.map((item) => {
        data.push({
          key: item.id,
          value: item.name,
        });
      });
      for (let item of this.headerData) {
        if (item.prop === "adminName") {
          item.selectOptions = data;
          item.selectOptions.unshift({ key: "0", value: "全部" });
        }
      }
    },
    async getData() {
      if (this.tableLoading) {
        return false;
      }
      this.tableLoading = true;
      const res = await GetAllStudentPage(this.systemInfo);
      this.tableData = res.result?.data;
      this.pagination.total = res.result?.totalRecords;

      this.emptyText = this.tableData ? "" : "暂无数据";
      this.tableLoading = false;
    },
    // 表行勾选
    handleSelectionChange(val) {
      this.handleSelection = val;
    },
    handleScopeCourse(row, state) {
      // 查看购买课程
      if (state == "PayCourse") {
        this.payCourseList = row.payCourses;
        this.CourseTitle = `学员[${
          row.studentName ? row.studentName : "暂未设置姓名"
        }]购买的课程`;
        this.dialogVisibleCourse = true;
      } else if (state == "remarks") {
        this.remarksList = row.remarks;
        this.remarksTitle = `学员[${
          row.studentName ? row.studentName : "暂未设置姓名"
        }]的备注信息`;
        this.dialogVisibleRemarks = true;
      }
    },
    // 分页
    changePagination(val) {
      if (this.tableLoading) {
        return false;
      }
      this.systemInfo.PageIndex = this.pagination.currentPage;
      this.systemInfo.PageSize = this.pagination.pageSize;
      this.getData();
    },
    // 获取下拉框数据
    async getStudentCategoryList() {
      let sourseList = [];

      const result = await GetCatetListByType(2);
      if (result.code == 1) {
        sourseList = result.result;
        // 来源渠道
        let sourseList1 = {},
          sourseList0 = [],
          sourseList2 = {},
          sourseList3 = {};
        if (sourseList && sourseList?.length) {
          sourseList.map((item) => {
            sourseList1.label = item.name;
            sourseList1.value = item.id;
            if (item.childModel && item.childModel?.length > 0) {
              sourseList1.children = [];
              item.childModel.map((item1) => {
                sourseList2.label = item1.name;
                sourseList2.value = item1.id;
                if (item1.childModel && item1.childModel?.length > 0) {
                  sourseList2.children = [];
                  item1.childModel.map((item2) => {
                    sourseList3.label = item2.name;
                    sourseList3.value = item2.id;
                    sourseList2.children.push(sourseList3);
                    sourseList3 = {};
                  });
                }
                sourseList1.children.push(sourseList2);
                sourseList2 = {};
              });
            }
            sourseList0.push(sourseList1);
            sourseList1 = {};
          });
          // this.sourseList1.push(...sourseList0);
          this.sourseList.push(...sourseList0);
        }
      }
      this.headerData.map((item) => {
        if (item.prop == "sourceStr") {
          item.selectOptions = this.sourseList;
        }
      });
    },
    // 搜索
    tableSearch(val) {
      if (!isNull(val.prop) && val.prop == "studentName") {
        this.systemInfo.name = val.value;
      }
      if (!isNull(val.prop) && val.prop == "sourceStr") {
        this.systemInfo.source = val.value?.length ? val.value[val.value?.length - 1] : 0;
      }
      if (!isNull(val.prop) && val.prop == "telNumber") {
        this.systemInfo.telNumber = val.value;
      }
      if (!isNull(val.prop) && val.prop == "qqNumber") {
        this.systemInfo.qqNumber = val.value;
      }
      if (!isNull(val.prop) && val.prop == "businessName") {
        this.systemInfo.businessId = val.value;
      }
      if (!isNull(val.prop) && val.prop == "handoverName") {
        this.systemInfo.handoverId = val.value;
      }

      this.systemInfo.PageIndex = 1;
      this.pagination.currentPage = 1;
      this.getData();
    },
  },
};
</script>

<style scoped>
.abow_dialog3 /deep/ .el-tabs__content {
  overflow: auto;
}
.container {
  padding: 20px;
  padding-right: 10px !important;
}

.table_title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #ececec;
  text-align: center;
  font-weight: bold;
  /* padding: 5px 0; */
  margin-top: 10px;
}

/deep/.el-table {
  margin-top: 0 !important;
}

.seat {
  height: 30px;
}

/deep/.el-input,
.el-textarea {
  font-size: 14px;
  /* width: 60%; */
}

/deep/.el-dialog {
  top: 30vh;
}
</style>
